import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import TestingTools from './TestingTools';
import augustaImage from '../images/augusta_front_9.png';
import putthausLogo from '../images/putthaus_logo.png';
import { DeviceInfo } from '../types';
import 'bootstrap/dist/css/bootstrap.min.css';

interface HomeProps {
  deviceInfo: DeviceInfo | null;
  loading: boolean;
  error: string | null;
  onFreePlay: () => Promise<void>;
  onPaidPlay: () => Promise<void>;
}

console.log('Augusta Image Path:', augustaImage);
console.log('Putthaus Logo Path:', putthausLogo);

const Home: React.FC<HomeProps> = ({ deviceInfo, loading, error, onFreePlay, onPaidPlay }) => {
  const { loginWithRedirect, isAuthenticated: auth0Authenticated } = useAuth0();
  const [mockAuthenticated, setMockAuthenticated] = React.useState(false);

  // Use mock authentication in development, Auth0 in production
  const isAuthenticated = process.env.NODE_ENV === 'development' 
    ? mockAuthenticated 
    : auth0Authenticated;

  console.log('Home component render:', { isAuthenticated, deviceInfo, loading, error });

  const handleLogin = () => {
    if (process.env.NODE_ENV === 'development') {
      setMockAuthenticated(true);
    } else {
      loginWithRedirect();
    }
  };

  const handlePlayClick = () => {
    if (!deviceInfo) return;
    
    if (deviceInfo.free_to_play) {
      onFreePlay();
    } else {
      onPaidPlay();
    }
  };

  return (
    <div className="home-content">
      <div className="course-image-container">
        <img 
          src={augustaImage} 
          alt="Augusta Front 9" 
          className="course-image"
          style={{ 
            objectFit: 'cover',
            width: '100%',
            height: '100%'
          }}
        />
      </div>
      <div className="button-container">
        {!isAuthenticated ? (
          <div className="login-container">
            <button
              className="btn btn-success btn-lg"
              onClick={handleLogin}
              style={{
                padding: '1rem 2rem',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
              }}
            >
              LOGIN TO PLAY
            </button>
          </div>
        ) : loading ? (
          <div className="loading-container">
            <div className="loading-text">LOADING...</div>
          </div>
        ) : error ? (
          <div className="error-container">
            <div className="error-text">ERROR</div>
          </div>
        ) : deviceInfo ? (
          <div className="play-game-container d-grid">
            <button
              className={`btn btn-success btn-lg w-100 ${deviceInfo.is_playing ? 'disabled' : ''}`}
              onClick={handlePlayClick}
              disabled={deviceInfo.is_playing}
              style={{
                padding: '1rem 2rem',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
              }}
            >
              {deviceInfo.is_playing ? (
                <div className="d-flex align-items-center justify-content-center">
                  PLAY IN PROGRESS...
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                deviceInfo.free_to_play ? 'FREE PLAY' : `PLAY FOR $${(deviceInfo.cost_per_play / 100).toFixed(2)}`
              )}
            </button>
          </div>
        ) : (
          <div className="no-device-found-container">
            <p>No device found for your account. Please ensure you are logged in and have a device assigned.</p>
          </div>
        )}
      </div>
      
      {process.env.NODE_ENV === 'development' && (
        <TestingTools onAuthChange={setMockAuthenticated} />
      )}
    </div>
  );
};

export default Home; 